/**
 * Mock data for Ghost Verification
 */

import type { GhostApplication, GhostVerificationStatus } from '../../types/ghostVerification';
import { generateId } from './mockData';

const statuses: GhostVerificationStatus[] = ['Pending', 'Approved', 'Rejected'];

const applicants = [
  { id: 'ghost-001', firstName: 'John', lastName: 'Smith', callSign: 'GHOST-12345', email: 'john.smith@example.com' },
  { id: 'ghost-002', firstName: 'Jane', lastName: 'Doe', callSign: 'GHOST-12346', email: 'jane.doe@example.com' },
  { id: 'ghost-003', firstName: 'Peter', lastName: 'Jones', callSign: 'GHOST-12347', email: 'peter.jones@example.com' },
  { id: 'ghost-004', firstName: 'Mary', lastName: 'Williams', callSign: 'GHOST-12348', email: 'mary.williams@example.com' },
  { id: 'ghost-005', firstName: 'David', lastName: 'Brown', callSign: 'GHOST-12349', email: 'david.brown@example.com' },
];

const generateMockApplications = (): GhostApplication[] => {
  const applications: GhostApplication[] = [];
  const now = new Date();

  const predefinedApplications: GhostApplication[] = [
    {
      id: generateId(),
      ghostId: 'ghost-001',
      firstName: 'John',
      lastName: 'Smith',
      email: 'john.smith@example.com',
      callSign: 'GHOST-12345',
      submittedOn: '2024-07-21T10:00:00Z',
      verificationStatus: 'Pending',
      type: 'Registration',
      ghostTier: 1,
      applicantName: 'GHOST-12345'
    },
    {
      id: generateId(),
      ghostId: 'ghost-002',
      firstName: 'Jane',
      lastName: 'Doe',
      email: 'jane.doe@example.com',
      callSign: 'GHOST-12346',
      submittedOn: '2024-07-20T14:30:00Z',
      verificationStatus: 'Pending',
      type: 'PiLicense',
      ghostTier: 0,
      applicantName: 'GHOST-12346'
    }
  ];

  for (let i = 0; i < 15; i++) {
    const applicant = applicants[i % applicants.length];
    const verificationStatus = statuses[Math.floor(Math.random() * statuses.length)];
    const submittedOn = new Date(now.getTime() - (i + 1) * 24 * 60 * 60 * 1000).toISOString();

    applications.push({
      id: generateId(),
      ghostId: applicant.id,
      firstName: applicant.firstName,
      lastName: applicant.lastName,
      email: applicant.email,
      callSign: applicant.callSign,
      submittedOn,
      verificationStatus,
      type: ['Registration', 'PiLicense', 'BondInfo'][Math.floor(Math.random() * 3)],
      ghostTier: Math.floor(Math.random() * 3),
      applicantName: applicant.callSign || `${applicant.firstName} ${applicant.lastName}`
    });
  }

  return [...predefinedApplications, ...applications];
};

export const mockGhostApplications: GhostApplication[] = generateMockApplications();

